module.exports = __webpack_public_path__ + "img/Essentials-And-A-Few-Comforts.f69d311e.jpg";